import _ from 'underscore';
import { createSelector } from 'reselect';
import entitiesSelector from './entities_selector';
import fakeStudentNames from '../lib/fake_names';

const stateSelector = state => state.studentCohortFilters;

const studentCohortFiltersSelector = entitiesSelector(stateSelector);

const getFilter = state => studentCohortFiltersSelector.getSelected(state)[0];


const getClassName = (student, index, capacity, filter) => {
  let classNames = [];

  if(index > capacity) {
    classNames.push('abl-student-unscheduled');
  }
  if(filter && filter.students && filter.students.includes(student)) {
    classNames.push(filter.selectedClass);
  }

  return classNames.join(' ');
};


const filterStudents = createSelector(
  state => getFilter(state),
  state => Array.from(Array(30).keys()),
  state => 24,
  (filter, students, capacity) => {

    let filterStudents = filter ? filter.students : [];

    return _.chain(students)
      .sortBy((student) => filterStudents.includes(student) ? 0 : 1)
      .map((student, i) => {
        return { 
          name: fakeStudentNames[student],
          className: getClassName(student, i, capacity, filter),
          triggers: i <= capacity ? ['hover'] : []
        }
      }).value();
  }
);

studentCohortFiltersSelector.getFilter = getFilter;
studentCohortFiltersSelector.filterStudents = filterStudents;

export default studentCohortFiltersSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/student_cohort_filters_selector.js
 **/